import axiosInstance from '../utils/axiosConfig';

export interface Program {
  id?: number;
  name?: string;
  partner_id?: number;
  partner?: { id: number; name: string };
}

export const listPrograms = async () => {
  const { data } = await axiosInstance.get<Program[]>('/api/v1/programs');
  return data;
};

export const createProgram = async (payload: Program) => {
  const { data } = await axiosInstance.post<Program>('/api/v1/programs', payload);
  return data;
};

export const updateProgram = async (id: number, payload: Program) => {
  const { data } = await axiosInstance.put<Program>(`/api/v1/programs/${id}`, payload);
  return data;
};

export const deleteProgram = async (id: number) => {
  await axiosInstance.delete(`/api/v1/programs/${id}`);
};

// Program Store related functions
export interface ProgramStore {
  id?: number;
  program_id: number;
  store_id: number;
  visiting_hours?: object; // min_days_between and max_days_between are now inside visiting_hours.limits
  visit_time_minutes?: number;
  rate?: number;
} 

export const assignStoreToProgram = async (payload: ProgramStore) => {
  const { data } = await axiosInstance.post<ProgramStore>('/api/v1/program-stores', payload);
  return data;
};

export const removeStoreFromProgram = async (id: number) => {
  await axiosInstance.delete(`/api/v1/program-stores/${id}`);
};

export const updateProgramStore = async (id: number, payload: Partial<ProgramStore>) => {
  const { data } = await axiosInstance.put<ProgramStore>(`/api/v1/program-stores/${id}`, payload);
  return data;
};

export const importProgramStoresExcel = async (program_id: number, import_type: string, file: File) => {
  const formData = new FormData();
  formData.append('program_id', String(program_id));
  formData.append('import_type', import_type);
  formData.append('file', file);
  const { data } = await axiosInstance.post('/api/v1/program-stores/import-excel', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 